import { Link, Outlet } from "react-router-dom";
import Stripe from '../../assets/images/stripe.png'
import Checkbox from '../../assets/images/checkbox.svg'
import Back from '../../assets/images/back.svg'
import Loginimage from '../../assets/images/succcess.svg'
import React, { useState } from "react";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Accordion, ButtonGroup, Container } from "react-bootstrap";
import { Button, Dialog, DialogContent, DialogContentText } from "@mui/material";
const Stripepage = () => {
  const [open, setOpen] = React.useState(false);
  const plans = [
    { name: "Base Plan", price: 5.95, recommended: false },
    { name: "Deluxe", price: 9.95, recommended: true },
    { name: "Premium", price: 19.95, recommended: false },
  ];
  const handleClickOpen = () => {
    setOpen(true);
  };
  const [selectedPlan, setSelectedPlan] = useState("Deluxe");
  const handleClose = () => {
    setOpen(false);
  };
  // const [otp, setOtp] = useState('true');
  const [otp, setOtp] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  const handleMouseUpPassword = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
  };
  return (
    <>
      <Container>
        <div className="col-12 text-center pt-4 login px-2 subscription">
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center"> <Link to="/subscription"><img src={Back} width="24" height={24} alt="Logo" /></Link></div>
            <div></div>
            <div>&nbsp;</div>
          </div>

          <img src={Stripe} width="100%"  height="100%" alt="Logo" style={{ marginLeft: "0px" }}  onClick={handleClickOpen} />
       
        </div>

        <React.Fragment>
          <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >

            <DialogContent>
              <DialogContentText id="alert-dialog-description" className="text-center">
                <img src={Loginimage} width="78" height={78} alt="Logo" /><br></br>
                <h5 className="text-dark mt-3 font-bold">Success!</h5>
                You have successfully subscribed <br></br>to our Deluxe plan.<br></br><br></br>
              </DialogContentText>
            <Link to="/homepage">
              <Button autoFocus className="w-100">
                OK
              </Button></Link>
            </DialogContent>

          </Dialog>
        </React.Fragment>

      </Container>


    </>
  );
};

export default Stripepage;
